import { useState, useEffect, useRef } from "react";
export default function HeroSection() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) setVisible(true);
    }, {
      threshold: 0.1
    });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return <section ref={ref} className="relative overflow-hidden" style={{
    backgroundPosition: "0% 0%",
    backgroundRepeat: "repeat",
    color: "rgb(42, 45, 43)",
    fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
    animation: "none 0s ease 0s 1 normal none running",
    position: "relative",
    overflow: "hidden",
    backgroundColor: "#FFFCF7"
  }}>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap');
      `}</style>

      <div className="absolute inset-0 w-full h-full" style={{
      backgroundImage: 'url("https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694540/img/spa_bg-FPPqL65JPdZuG7KqU6iTxM.webp")',
      backgroundSize: "cover",
      backgroundPosition: "50% 50%",
      backgroundRepeat: "repeat",
      color: "rgb(42, 45, 43)",
      fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
      animation: "none 0s ease 0s 1 normal none running",
      position: "absolute",
      opacity: 0.03,
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 0
    }} />

      <div className="page-container relative z-10" style={{
      paddingTop: "80px",
      paddingBottom: "128px"
    }}>
        <div className="flex flex-col md:flex-row items-center gap-12 md:gap-20">
          <div className={`flex-1 flex flex-col items-start transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          maxWidth: "560px"
        }}>
            <div className="flex items-center gap-2 mb-6" style={{
            backgroundColor: "rgba(245, 240, 232, 0.9)",
            border: "1px solid rgba(31, 58, 46, 0.2)",
            borderRadius: "9999px",
            padding: "6px 14px"
          }}>
              <span style={{
              color: "#C8985C",
              display: "flex",
              alignItems: "center"
            }}>
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M9.937 15.5A2 2 0 0 0 8.5 14.063l-6.135-1.582a.5.5 0 0 1 0-.962L8.5 9.936A2 2 0 0 0 9.937 8.5l1.582-6.135a.5.5 0 0 1 .963 0L14.063 8.5A2 2 0 0 0 15.5 9.937l6.135 1.581a.5.5 0 0 1 0 .964L15.5 14.063a2 2 0 0 0-1.437 1.437l-1.582 6.135a.5.5 0 0 1-.963 0z"></path>
                  <path d="M20 3v4"></path>
                  <path d="M22 5h-4"></path>
                  <path d="M4 17v2"></path>
                  <path d="M5 18H3"></path>
                </svg>
              </span>
              <span style={{
              color: "#1F3A2E",
              fontSize: "11px",
              fontWeight: 500,
              letterSpacing: "0.08em",
              textTransform: "uppercase"
            }}>
                SPA CASH FLOW. GUARANTEED.
              </span>
            </div>

            <h1 style={{
            color: "rgb(31, 58, 46)",
            fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
            fontSize: "60px",
            fontWeight: "400",
            lineHeight: "66px",
            letterSpacing: "-1.5px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            animation: "none 0s ease 0s 1 normal none running",
            marginBottom: "24px"
          }} className="w-full">
              Join PrepayQR in{" "}
              <span style={{
              fontWeight: 700
            }}>60 Seconds</span>
              {" — "}
              <em style={{
              fontStyle: "italic",
              color: "#C8985C",
              fontWeight: 400
            }}>
                No
                <br />
                Application, No Commitment
              </em>
            </h1>

            <p style={{
            color: "rgba(42, 45, 43, 0.8)",
            fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
            fontSize: "18px",
            fontWeight: "400",
            lineHeight: "29.25px",
            border: "0px solid oklch(0.69 0.04 165 / 0.25)",
            animation: "none 0s ease 0s 1 normal none running",
            maxWidth: "460px",
            marginBottom: "32px"
          }}>
              A quick soft&#8209;enrollment to see if your spa qualifies and
              unlock instant tools to streamline your bookings and payments. Turn
              relaxation into recurring revenue.
            </p>

            <div className="flex flex-col items-start gap-3">
              <button style={{
              color: "rgb(31, 58, 46)",
              fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
              fontSize: "16px",
              fontWeight: "700",
              lineHeight: "24px",
              letterSpacing: "0.8px",
              backgroundColor: "rgb(200, 152, 92)",
              borderRadius: "9999px",
              border: "1px solid rgba(200, 152, 92, 0.4)",
              padding: "14px 28px",
              textTransform: "uppercase",
              textAlign: "center",
              animation: "none 0s ease 0s 1 normal none running",
              boxShadow: "oklab(0.322641 -0.038253 0.0109689 / 0.2) 0px 10px 15px -3px, oklab(0.322641 -0.038253 0.0109689 / 0.2) 0px 4px 6px -4px",
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              gap: "8px",
              transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
            }} onMouseEnter={e => {
              (e.currentTarget as HTMLButtonElement).style.opacity = "0.9";
              (e.currentTarget as HTMLButtonElement).style.transform = "scale(1.03)";
            }} onMouseLeave={e => {
              (e.currentTarget as HTMLButtonElement).style.opacity = "1";
              (e.currentTarget as HTMLButtonElement).style.transform = "scale(1)";
            }}>
                START SOFT ENROLLMENT (60 SECONDS)
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M5 12h14"></path>
                  <path d="m12 5 7 7-7 7"></path>
                </svg>
              </button>

              <div className="flex items-center gap-1.5">
                <span style={{
                color: "rgba(31, 58, 46, 0.6)",
                display: "flex",
                alignItems: "center"
              }}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12 2 2 4-4"></path>
                  </svg>
                </span>
                <p style={{
                color: "rgba(42, 45, 43, 0.7)",
                fontFamily: 'ui-sans-serif, system-ui, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"',
                fontSize: "12px",
                fontWeight: "400",
                lineHeight: "16px",
                border: "0px solid oklch(0.69 0.04 165 / 0.25)",
                animation: "none 0s ease 0s 1 normal none running"
              }}>
                  No credit card. No legal review. Just a phone number.
                </p>
              </div>
            </div>
          </div>

          <div className={`flex-shrink-0 transition-all duration-700 ${visible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
          transitionDelay: "200ms",
          width: "100%",
          maxWidth: "440px"
        }}>
            <div className="relative w-full" style={{
            borderRadius: "16px",
            overflow: "hidden",
            boxShadow: "0 20px 40px rgba(31, 58, 46, 0.12), 0 4px 12px rgba(31, 58, 46, 0.08)",
            backgroundColor: "#FFFFFF"
          }}>
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1694540/img/qr_table-E6uW6JmqppJ5HbamrnyX5A.webp" alt="Luxury Spa table with gold QR code" className="w-full h-auto block" style={{
              borderRadius: "16px 16px 0 0"
            }} />

              <div className="flex items-center gap-3" style={{
              backgroundColor: "#FFFFFF",
              padding: "12px 16px",
              borderRadius: "0 0 16px 16px"
            }}>
                <div className="flex-shrink-0 flex items-center justify-center" style={{
                width: "32px",
                height: "32px",
                borderRadius: "50%",
                backgroundColor: "#1F3A2E"
              }}>
                  <span style={{
                  color: "#FFFFFF",
                  fontFamily: 'ui-serif, Georgia, Cambria, "Times New Roman", Times, serif',
                  fontSize: "14px",
                  fontWeight: 700
                }}>
                    Q
                  </span>
                </div>

                <div className="flex flex-col">
                  <span style={{
                  color: "#C8985C",
                  fontSize: "10px",
                  fontWeight: 600,
                  letterSpacing: "0.08em",
                  textTransform: "uppercase",
                  lineHeight: "14px"
                }}>
                    THE SILENT CLOSER™
                  </span>
                  <span style={{
                  color: "#1F3A2E",
                  fontSize: "14px",
                  fontWeight: 700,
                  lineHeight: "20px"
                }}>
                    Taped to Massage Tables
                  </span>
                  <span style={{
                  color: "rgba(42, 45, 43, 0.7)",
                  fontSize: "12px",
                  fontWeight: 400,
                  lineHeight: "18px"
                }}>
                    Clients scan, pay, and rebook themselves.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}